import React from 'react';
import { Modal } from 'semantic-ui-react';
import { RoundButton, ThemedButton } from 'components/lib/UI';

const AssignIdea = ({
  isOpen, onClose, assignIdea, loading,
}) => (
  <Modal
    open={isOpen}
    onClose={onClose}
    style={{ padding: 20, backgroundColor: '#fff' }}
  >
    <h3>Assign idea to your account?</h3>
    <p>
      Assigning this idea to your account will allow you to return to it later to continue editing, as well as reply to comments.
    </p>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <RoundButton content="Cancel" onClick={onClose} />
      <ThemedButton primary content="Assign" loading={loading} icon="add user" onClick={assignIdea} />
    </div>
  </Modal>
);

export default AssignIdea;
